export default "__VITE_ASSET__CTXR6vuy__"